/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'ACESUserInfo' store object.
 * @namespace ACESUserInfoSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAACESUserInfo';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserInfoSelectors
   */
  static fetchGetGenderEmailAddress = state =>
    state[selectors.moduleIdentifier].fetchGetGenderEmailAddress.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserInfoSelectors
   */
  static isFetchingFetchGetGenderEmailAddress = state =>
    state[selectors.moduleIdentifier].isFetchingFetchGetGenderEmailAddress.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserInfoSelectors
   */
  static fetchGetGenderEmailAddressError = state =>
    state[selectors.moduleIdentifier].fetchGetGenderEmailAddressError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserInfoSelectors
   */
  static postModifyEmailAddress = state =>
    state[selectors.moduleIdentifier].postModifyEmailAddress.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserInfoSelectors
   */
  static isFetchingPostModifyEmailAddress = state =>
    state[selectors.moduleIdentifier].isFetchingPostModifyEmailAddress.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESUserInfoSelectors
   */
  static postModifyEmailAddressError = state =>
    state[selectors.moduleIdentifier].postModifyEmailAddressError.payload;
}
